var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slot",staticClass:"component-tip"},[_vm._t("default"),_c('div',{ref:"tip",staticClass:"glossary-top__tip"},[_vm._t("tooltip")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }